"use client"

import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { cn } from "@/lib/utils"
import { Circle } from "lucide-react"

interface RadioItemCustomProps {
  value: string
  label: string
  description?: string
  className?: string
}

export const RadioItemCustom = React.forwardRef<
  HTMLButtonElement,
  RadioItemCustomProps & React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ value, label, description, className, ...props }, ref) => {
  const itemId = React.useId()
  
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      value={value}
      id={itemId}
      className={cn(
        "relative flex items-start gap-3 p-3 border rounded-lg cursor-pointer transition-all text-left",
        "hover:bg-muted/50 hover:border-primary",
        "data-[state=checked]:border-primary data-[state=checked]:bg-primary/5",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )}
      {...props}
    >
      <div className={cn(
        "mt-0.5 aspect-square h-4 w-4 rounded-full border border-primary shrink-0 flex items-center justify-center"
      )}>
        <RadioGroupPrimitive.Indicator>
          <Circle className="h-2.5 w-2.5 fill-primary text-primary" />
        </RadioGroupPrimitive.Indicator>
      </div>
      <div className="flex-1">
        <div className="font-medium text-sm">{label}</div>
        {description && (
          <div className="text-xs text-muted-foreground mt-1">
            {description}
          </div>
        )}
      </div>
    </RadioGroupPrimitive.Item>
  )
})
RadioItemCustom.displayName = "RadioItemCustom"
